import { Progress as ChakraProgress } from '@chakra-ui/react'
import * as React from 'react'

import { InfoTip } from './toggle-tip'

export const ProgressBar = React.forwardRef<
  HTMLDivElement,
  ChakraProgress.RootProps
>(function ProgressBar(props, ref) {
  return (
    <ChakraProgress.Root
      ref={ref}
      striped
      animated
      borderRadius="full"
      {...props}
    >
      <ChakraProgress.Track borderRadius="full">
        <ChakraProgress.Range
          css={{
            '--stripe-size': '0.75rem',
          }}
        />
      </ChakraProgress.Track>
    </ChakraProgress.Root>
  )
})

export interface ProgressLabelProps extends ChakraProgress.LabelProps {
  info?: React.ReactNode
}

export const ProgressLabel = React.forwardRef<
  HTMLDivElement,
  ProgressLabelProps
>(function ProgressLabel(props, ref) {
  const { children, info, ...rest } = props
  return (
    <ChakraProgress.Label {...rest} ref={ref}>
      {children}
      {info && <InfoTip>{info}</InfoTip>}
    </ChakraProgress.Label>
  )
})

export const ProgressRoot = ChakraProgress.Root
export const ProgressValueText = ChakraProgress.ValueText
